import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Divider, Grid } from '@material-ui/core';
import { useRecoilState } from 'recoil';
import { mainBlueColor } from '../../GlobalState';
import { getConstructsInfo } from '../../apicalls/WorkingBudgetPage';
import { NOT_LOGGED_IN } from '../../const/Const';

type TProps = {
  changeLoggedInData: any;
  setErrorMessage: any;
  setOpen: any;
  workingBudgetId: number;
};

/**
 * 工事情報
 * @constructor
 */
export const ConstructsInfo: React.FC<TProps> = (props: TProps) => {
  const { workingBudgetId, changeLoggedInData, setErrorMessage, setOpen } =
    props;

  const [mainColor] = useRecoilState(mainBlueColor);
  const classes = useStyles({ mainColor: mainColor });

  const [code, setCode] = useState('');
  const [construct_name, setConstruct_name] = useState('');
  const [client_name, setClient_name] = useState('');

  useEffect(() => {
    getConstructsInfo(workingBudgetId).then(data => {
      if (data.data === NOT_LOGGED_IN) {
        changeLoggedInData(NOT_LOGGED_IN);
      } else {
        if (typeof data.data === 'string') {
          setErrorMessage(data.data);
          setOpen(true);
        } else {
          setCode(data.constructsInfo.code);
          setConstruct_name(data.constructsInfo.construct_name);
          setClient_name(data.constructsInfo.client_name);
        }
      }
    });
  }, []);

  return (
    <div className={classes.container}>
      <Grid item xs={12}>
        <Divider style={{ backgroundColor: '#FFFFFF', marginLeft: 15 }} />
        <div className={classes.subContainer}>
          <div className={classes.textMainContainer}>
            <div className={classes.textContainer}>見積書番号</div>
          </div>
          <div className={classes.inputMainContainer}>
            <div className={classes.fixedTextContainer}>
              {code ? String(code).padStart(5, '0') : 0}
            </div>
          </div>
        </div>

        <Divider style={{ backgroundColor: '#FFFFFF', marginLeft: 15 }} />
        <div className={classes.subContainer}>
          <div className={classes.textMainContainer}>
            <div className={classes.textContainer}>工事件名</div>
          </div>
          <div className={classes.inputMainContainer}>
            <div className={classes.fixedTextContainer}>
              <div style={{ fontSize: 11 }}>{construct_name}</div>
            </div>
          </div>
        </div>

        <Divider style={{ backgroundColor: '#FFFFFF', marginLeft: 15 }} />
        <div className={classes.subContainer}>
          <div className={classes.textMainContainer}>
            <div className={classes.textContainer}>顧客名</div>
          </div>
          <div className={classes.inputMainContainer}>
            <div className={classes.fixedTextContainer}>{client_name}</div>
          </div>
        </div>
      </Grid>
    </div>
  );
};

type TStyleProps = {
  mainColor: string;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({
    container: {
      width: '30%',
      padding: 10
    },
    subContainer: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row'
    },
    textMainContainer: {
      display: 'flex',
      backgroundColor: props => props.mainColor,
      width: '50%',
      height: 60,
      alignItems: 'center'
    },
    textContainer: {
      marginLeft: 15,
      color: '#FFFFFF',
      fontSize: 14
    },
    inputMainContainer: {
      display: 'flex',
      backgroundColor: '#e8e8e8',
      height: 60,
      alignItems: 'center',
      width: '100%'
    },
    fixedTextContainer: {
      fontSize: 14,
      marginLeft: 15
    }
  })
);
